module.exports = __webpack_public_path__ + "static/media/02 - Hat Closed.e9d3717f.wav";